import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.175 2.65a8.524 8.524 0 1 1 0 17.046 8.524 8.524 0 1 1 0-17.046m7.753 15.112a10.13 10.13 0 0 0 2.422-6.589C21.35 5.555 16.794 1 11.175 1S1 5.555 1 11.173s4.556 10.173 10.175 10.173c2.512 0 4.811-.91 6.586-2.418l3.83 3.829a.825.825 0 1 0 1.166-1.167z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }